import React from "react";
import { withRouter } from "react-router";
import { Button, Layout, Menu } from "antd";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useAuth0 } from "@auth0/auth0-react";

const { Search } = Input;

const styles = {
  layoutHeader: () => ({
    backgroundColor: '#f4f3ef',
    padding: "0 32px",
  }),
  menu: () => ({
    position: "absolute",
    float: "right",
    right: 0,
    lineHeight: "64px",
  }),
  user: () => ({
    float: "right",
  }),
};

const Header = ({ location, collapsed, setCollapsed }) => {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <Layout.Header style={styles.layoutHeader()}>
      <Menu
        mode="horizontal"
        style={{ backgroundColor: "#F4F3EF", width: "100%" }}
      >
        <Menu.Item
          key="collapse"
          style={{ pointerEvents: "none" }}
          selectable={false}
          disabled={true}
        >
          <Button
            style={{ marginLeft: 0, pointerEvents: "all" }}
            onClick={() => setCollapsed(!collapsed)}
            shape="circle"
          >
            {collapsed ? <CaretRightOutlined /> : <CaretLeftOutlined />}
          </Button>
        </Menu.Item>
        <Menu.Item
          style={{
            color: "#66615B",
            pointerEvents: "none",
            float: "left",
            fontSize: "150%",
          }}
        >
          {location.pathname.length > 1
            ? location.pathname[1].toUpperCase() + location.pathname.slice(2)
            : ""}
        </Menu.Item>
        <Menu.Item
          key="search"
          style={{ pointerEvents: "none" }}
          selectable={false}
        ></Menu.Item>
        <span
          style={{
            pointerEvents: "none",
            position: "absolute",
            right: 0,
            top: "20px",
            bottom: 0,
          }}
        >
          <Menu.Item
            key="user"
            style={{ float: "right", pointerEvents: "none" }}
            selectable={false}
          >
            {location.pathname == "/dashboard" ? (
              <Search
                placeholder="Search..."
                allowClear
                onSearch={(value) => {
                  console.log(value);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  pointerEvents: "all",
                }}
              />
            ) : (
              ""
            )}
          </Menu.Item>
        </span>
      </Menu>
    </Layout.Header>
  );
};

export default withRouter(Header);
